// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"zf","itemsContainer":"Af"};